var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgObora(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_10582513",
    enableBackground: "new 0 0 464 464",
    height: 512,
    viewBox: "0 0 464 464",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m358.849 80.32-126.83-40.82-126.83 40.82-60.72 77.72v287.09h375.1v-287.08z",
    fill: "#ff6d7a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m84.469 142.37v282.76h-40v-227.09c3.51-1.55 6.79-4.29 9.47-8.44z",
    fill: "#ff8c95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m109.179 13.28 7.71 44.636-26.448 41.281-36.852 11.743 1.62-95.21c.14-8.73 7.26-15.73 15.99-15.73h22.22c7.78 0 14.44 5.6 15.76 13.28z",
    fill: "#ff6d7a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m109.119 13h-11.92c-8.73 0-15.85 7-15.99 15.73l-.7 41.32-.88.29-26.04 40.6 1.62-95.21c.14-8.73 7.26-15.73 15.99-15.73h22.22c7.68 0 14.28 5.46 15.7 13z",
    fill: "#ff8c95"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m444.579 425.13c25.88 0 25.86 38.87 0 38.87h-425.12c-10.738 0-19.44-8.7-19.44-19.44 0-10.73 8.7-19.43 19.44-19.43z",
    fill: "#befa91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m462.999 438.13h-416.54c-13.493 0-22.751 13.353-18.35 25.87h-8.65c-10.739 0-19.44-8.7-19.44-19.44 0-10.73 8.7-19.43 19.44-19.43h425.12c10.04 0 16.18 5.84 18.42 13z",
    fill: "#daffbf"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m331.079 277.9v147.23h-198.16v-147.23c0-8.83 7.16-16 16-16h166.16c8.84 0 16 7.17 16 16z",
    fill: "#cbe3fa"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m331.079 277.9v4h-142.16c-8.84 0-16 7.17-16 16v127.23h-40v-147.23c0-8.83 7.16-16 16-16h166.16c8.84 0 16 7.17 16 16z",
    fill: "#eef7ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m314.569 425.13h-18.84l-55.71-60.98v60.98h-16v-61.01l-55.74 61.01h-18.84c0-5.892.235-2.19 71.73-81.61-71.112-79.003-71.73-75.712-71.73-81.62h18.84l55.74 61.01v-61.01h16v60.98l55.71-60.98h18.84c0 5.892-.234 2.191-71.73 81.61 71.111 79.003 71.73 75.712 71.73 81.62z",
    fill: "#9ec7f0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m276.619 177.5c23.9 0 23.88 35.89 0 35.89h-89.2c-23.9 0-23.88-35.89 0-35.89z",
    fill: "#cbe3fa"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m293.629 189.5h-77.21c-14.62 0-20.3 13.46-17.01 23.89h-11.99c-23.9 0-23.88-35.89 0-35.89h89.2c9.27 0 14.94 5.39 17.01 12z",
    fill: "#eef7ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m265.289 144.23v33.27h-66.54v-33.27c0-44.28 66.54-44.3 66.54 0z",
    fill: "#e84857"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m446.049 166.46c15.113 23.564-20.392 47.231-35.95 23.14l-51.25-79.28-126.83-50.82-126.83 50.82-51.25 79.28c-15.528 24.046-51.074.453-35.95-23.14l61.64-96.12 152.39-50.82 152.39 50.82z",
    fill: "#cbe3fa"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m257.299 28.52-153.99 50.82-62.28 96.12c-5.61 8.66-4.31 17.33.35 23.64-16.28 4.07-35.141-14.311-23.39-32.64l61.64-96.12 152.39-50.82c2.758.982-9.653-3.436 25.28 9z",
    fill: "#eef7ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObora);
export default __webpack_public_path__ + "static/media/obora.1189653c11188e6a14953ff07c757360.svg";
export { ForwardRef as ReactComponent };